import store from '@/store';

export default (to, from, next) => {
    const is_phone_number_change_on_dashboard_allowed = store.getters.is_phone_number_change_on_dashboard_allowed;

    return {
        allow: is_phone_number_change_on_dashboard_allowed,
        redirect: { name: 'not-found' },
    }
};
